/**
 * StatusBadge — response status badge for the response tracker quadrant.
 *
 * COORD-26: On Track (green), At Risk (amber), Blocked (red). Theme-aware.
 */
const STATUS_CLASSES = {
  "On Track": "bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400",
  "At Risk": "bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-400",
  Blocked: "bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-400",
};

export default function StatusBadge({ status }) {
  const classes = STATUS_CLASSES[status] || STATUS_CLASSES["On Track"];

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-[9px] font-bold uppercase tracking-wide flex-shrink-0 ${classes}`}
    >
      {status}
    </span>
  );
}
